import cx from '@travel/ui/utils/classnames';

import styles from './hotelMembershipExchangeLabel.module.scss';

type Props = {
  className?: string;
  hotelMembershipNameTxt: string;
};

const HotelMembershipExchangeLabel = ({ className = '', hotelMembershipNameTxt = '' }: Props) => {
  return (
    <div className={cx(styles.hotelMembershipLabel, className)}>
      <span className={styles.hotelMembershipText}>{hotelMembershipNameTxt}</span>
    </div>
  );
};

export default HotelMembershipExchangeLabel;
